import React, { useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { setToast } from '../../store/slices/toastSlice';

const Toast: React.FC = () => {
    const dispatch = useDispatch();
    const toast: any = useSelector((state: RootState) => state.toast);

    useEffect(() => {
        if (toast.open) {
            const duration = 10000;
            const timer = setTimeout(() => {
                dispatch(setToast({ message: '', severity: '', open: false }));
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [toast.open, dispatch, toast.severity]);

    const handleClose = () => {
        dispatch(setToast({ message: '', severity: '', open: false }));
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            open={toast.open}
            onClose={handleClose}
        >
            <Alert 
                onClose={handleClose} 
                severity={toast.severity} 
                sx={{ 
                    width: '100%',
                    fontSize: '16px',
                    padding: '10px 20px',
                }} 
                className='toast'
            >
                {toast.message}
            </Alert>
        </Snackbar>
    );
};

export default Toast;
